import axios from "axios";
import { baseURL } from "./Api";
import Cookie from "cookie-universal";

export const Axios = axios.create({ baseURL });

// Attach the auth token fresh on every request
Axios.interceptors.request.use((config) => {
  const token = Cookie().get("rasheed");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// On 401 → clear session and redirect to login
Axios.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error.response?.status === 401) {
      const cookie = Cookie();
      cookie.remove("rasheed",       { path: "/" });
      cookie.remove("user_name",     { path: "/" });
      cookie.remove("refresh_token", { path: "/" });
      // Only redirect if not already on the login page
      if (!window.location.pathname.startsWith("/login")) {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);
